/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { AiOutlineCheck } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import validateCnpj from '../../services/utils/validateCnpj';
import validateCpf from '../../services/utils/validateCpf';

import {
  ButtonContainer,
  CpfContainer,
  Description,
  LeftContainer,
  Main,
  LogoContainer,
  Wrapper,
  Image,
  Container,
  CardContainer,
  Date,
  Title,
  Subtitle,
  PaymentCard,
  Icon,
  IconCopyFile,
  IconPrinter,
} from './styles';
import { FiFileText } from 'react-icons/fi';
import Toast from '../../components/Toast';
import { toast } from 'react-toastify';
import format from '../../services/utils/formatCPFandCNPJ';
import CookiesMessage from '../../components/CookiesMessage/CookiesMessage';
import api from '../../services/api';
import { formatDate } from '../../utils/formatDate';
import { formatCurrency } from '../../utils/formatCurrency';
import { BiCalendar } from 'react-icons/bi';
import { FaChevronRight } from 'react-icons/fa';

type PaymentMethods = {
  icon: string;
  text: string;
  code: string;
};

const paymentMethods = [
  {
    icon: 'linhaDigitavel',
    text: 'Copiar linha digitável',
    code: 'linhaDigitavel',
  },
  {
    icon: 'imprimirBoleto',
    text: 'Imprimir Boleto',
    code: 'imprimirBoleto',
  },
];

const FillCpfBillet: React.FC = () => {
  const [cpf, setCpf] = useState('');
  const [validCpf, setValidCpf] = useState(false);
  const [billetList, setListBillet] = useState<GQL.ListBilletResponse[]>();
  const [step, setStep] = useState(1);
  const [filledCpf, setFilledCpf] = useState(false);
  const [title, setTitle] = React.useState(' ');
  const paymentMethodList = useRef<PaymentMethods[]>(paymentMethods);
  const downloadLink = useRef<HTMLAnchorElement>(null);

  const {
    assessoriaImage,
    imagemCentralHome,
    imagemCentralMobile,
    tituloSite,
  } = useSelector((state: ApplicationState) => {
    return {
      assessoriaImage: state.config.assessoriaImage,
      imagemCentralHome: state.config.imagemCentralHome,
      tituloSite: state.config.tituloSite,
      imagemCentralMobile: state.config.imagemCentralMobile,
    };
  });

  const validaCpfCnpj = useCallback((val: any) => {
    if (val && val.length > 0) {
      if (val && val.length === 10) {
        setFilledCpf(true);
        setValidCpf(validateCpf('0' + val));
      }
      if (val && val.length === 11) {
        setFilledCpf(true);
        setValidCpf(validateCpf(val));
      }
      if (val.length > 11 && val.length < 14) {
        setValidCpf(false);
      }
      if (val.length === 14) {
        setFilledCpf(true);
        setValidCpf(validateCnpj(val));
      }
      if (val.length < 10) {
        setFilledCpf(false);
        setValidCpf(false);
      }
    }
  }, []);

  const fetchDataCallback = useCallback(async () => {
    try {
      const res = await api.rpaGetListBilletByCpf({ cpf });
      setListBillet(res);
      setStep(2);
    } catch (error) {
      console.error(`Erro ao buscar dados do CPF: ${error}`);
    }
  }, [cpf]);

  const handleSendCPF = () => {
    if (cpf.length < 10 || (cpf.length > 11 && cpf.length < 14) || !validCpf) {
      return toast.error(
        <Toast
          title='Credenciais inválidas!'
          description='Coloque um CPF ou CNPJ válido para prosseguir!'
        />
      );
    }
    fetchDataCallback();
  };

  useEffect(() => {
    if (tituloSite) {
      setTitle(tituloSite);
    } else setTitle('AUTO NEGOCIADOR');
    document.title = title;
  }, [tituloSite, title]);

  useEffect(() => {
    validaCpfCnpj(cpf);
  }, [cpf, validaCpfCnpj]);

  const fetchPdf = async (id: string, databaseId: number) => {
    const { data } = await api.getBillet({
      id,
      databaseId,
    });

    if (!data) return;

    downloadLink.current!.target = '_self';
    downloadLink.current!.href = `data:application/pdf;base64,${data}`;
    downloadLink.current!.click();
  };

  const copyToClipboard = (text: string) => {
    const input = document.createElement('input');
    document.body.appendChild(input);
    input.value = text;
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    toast.error(
      <Toast
        title={'Aviso'}
        type={'success'}
        description={'Copiado para Área de Transferência'}
      />
    );
  };

  const getSerialNumber = async (id: string, databaseId: number) => {
    const { data } = await api.rpaGetLinhaDigBillet({
      id,
      databaseId,
    });
    copyToClipboard(data ?? '');
  };

  const handlePaymentMethod = (
    code: string,
    billet: GQL.ListBilletResponse
  ) => {
    switch (code) {
      case 'linhaDigitavel':
        getSerialNumber(billet.id, billet.databaseId);
        break;
      case 'imprimirBoleto':
        fetchPdf(billet.id, billet.databaseId);
        break;
      default:
        return;
    }
  };

  const getIcon = (icon: string) => {
    switch (icon) {
      case 'linhaDigitavel':
        return <IconCopyFile />;
      case 'imprimirBoleto':
        return <IconPrinter />;
      default:
        return;
    }
  };

  return (
    <Wrapper
      homeImg={step === 1 ? imagemCentralHome : ''}
      homeMobileImg={step === 1 ? imagemCentralMobile : ''}
      assessoriaImg={step === 1 ? assessoriaImage : ''}
      step={step}
    >
      {step === 1 && (
        <Main>
          <LeftContainer assessoriaImg={assessoriaImage}>
            <Description>
              <h1>Negocie sua dívida</h1>
              <p>Preencha abaixo o CPF ou CNPJ do titular:</p>
            </Description>
            <CpfContainer valid={validCpf} filled={filledCpf}>
              <input
                onKeyPress={(event) => {
                  if (event.key === 'Enter') handleSendCPF();
                }}
                type='tel'
                placeholder='Digite seu CPF'
                value={format(cpf)}
                onChange={(e) =>
                  setCpf(
                    e.target.value
                      .replace(/[^0-9]/g, '')
                      .replace(/(\..*)\./g, '$1')
                  )
                }
                maxLength={17}
              />
              <div className='invalidCPF'>
                {cpf && cpf?.length > 11 ? 'CNPJ' : 'CPF'} inválido
              </div>
              <span>
                <AiOutlineCheck />
              </span>
            </CpfContainer>
            <ButtonContainer>
              <button type='button' onClick={handleSendCPF}>
                AVANÇAR
              </button>
            </ButtonContainer>
            <CookiesMessage />
            {assessoriaImage && (
              <LogoContainer>
                <Image src={assessoriaImage} />
              </LogoContainer>
            )}
          </LeftContainer>
        </Main>
      )}
      {step === 2 && (
        <Wrapper billetsQuantity={billetList && billetList.length}>
          <Container>
            {/* Situação sem boleto */}
            {billetList && !billetList.length && (
              <>
                <Title>Meus Boletos</Title>
                <Subtitle>
                  Não há boletagem para o{' '}
                  {cpf && cpf?.length > 11 ? 'CNPJ' : 'CPF'} inserido
                </Subtitle>
              </>
            )}

            {/* Situação com mais de um  boleto*/}
            {billetList && billetList.length > 1 && (
              <>
                <Title>Meus Boletos</Title>
                <Subtitle>
                  Selecione um boleto abaixo para ver mais detalhes.
                </Subtitle>
                {billetList?.map((billet, index) => (
                  <CardContainer
                    key={index}
                    onClick={() => {
                      setListBillet([billet]);
                    }}
                  >
                    <div className='row'>
                      <div className='left'>
                        <Date>
                          <FiFileText /> Contrato:{' '}
                          <b style={{ marginLeft: '5px' }}>
                            {' '}
                            {billet.originalContract ?? billet.contract}
                          </b>
                        </Date>
                        <Date>
                          <BiCalendar />
                          Emissão:{' '}
                          <b style={{ marginLeft: '5px' }}>
                            {formatDate(billet.issueDate)}
                          </b>
                        </Date>
                        <Date>
                          <BiCalendar /> Vencimento:
                          <b style={{ marginLeft: '5px' }}>
                            {formatDate(billet.dueDate)}
                          </b>
                        </Date>
                      </div>
                      <div className='right'>
                        <p className='text'>Valor total:</p>
                        <p className='price'>
                          <span>Valor total: </span>
                          {formatCurrency(billet.value) ?? 0}
                        </p>
                      </div>
                    </div>
                  </CardContainer>
                ))}
              </>
            )}

            {/* Situação com apenas 1 boleto */}
            {billetList && billetList.length === 1 && (
              <>
                <a
                  ref={downloadLink}
                  download={'boleto.pdf'}
                  style={{ display: 'none' }}
                />
                <div
                  dangerouslySetInnerHTML={{ __html: billetList[0].billetText }}
                />
                {paymentMethodList.current?.map((e) => (
                  <PaymentCard
                    key={e.code}
                    onClick={() => handlePaymentMethod(e.code, billetList[0])}
                  >
                    <span>{getIcon(e.icon)}</span>
                    <p className='text'>{e.text}</p>
                    <Icon>
                      <FaChevronRight style={{ height: 24, width: 24 }} />
                    </Icon>
                  </PaymentCard>
                ))}
              </>
            )}
          </Container>
        </Wrapper>
      )}
    </Wrapper>
  );
};

export default FillCpfBillet;
